import { useTranslation } from 'react-i18next';
import { ProductSchedule } from '../../../@types/model/productSchedule';
import { useEffect, useState } from 'react';
import { getProductTypes, productTypeState } from 'recoil/productTypeState';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ProductType } from '../../../@types/model/productType';
import { DeliveryRequestItem } from '../../../@types/model/deliveryRequest';

type ScheduleBarProps = {
  schedule: ProductSchedule;
  slot_amount: number;
  slotsNumber: number;
  expand: boolean;
  deliveryRequestItems: DeliveryRequestItem[];
};

const ScheduleBar = (props: ScheduleBarProps) => {
  const { t } = useTranslation();
  const [total, setTotal] = useState(1);
  const [expand, setExpand] = useState(1);

  useEffect(() => {
    const total = props.schedule.schedule.map((s) => s.quantity).reduce((pv, c) => (pv += c));
    setTotal(total);
    setExpand(1);
    if (props.expand) {
      let max = 0;
      props.schedule.schedule.forEach((s) => {
        if (s.quantity > max) max = s.quantity;
      });
      setExpand(total / max);
    }
  }, [props]);

  const productTypes: ProductType[] = useRecoilValue(productTypeState);
  const setProductType = useSetRecoilState(productTypeState);

  useEffect(() => {
    if (productTypes.length === 0) {
      getProductTypes().then((productTypes: ProductType[]) => {
        setProductType(productTypes);
      });
    }
  }, []);

  return (
    <div className={'schedule-bar' + (props.expand ? ' expand' : '')}>
      {!props.expand ? (
        <div className="crianza-title">
          {t('phases')}
          <b>
            {t('breeding')} <i>{props.schedule?.product_schedule_template?.name}</i>{' '}
          </b>
        </div>
      ) : null}
      {props.schedule?.schedule.map((product) => {
        let filled = 0;
        props.deliveryRequestItems.forEach((dri: DeliveryRequestItem) => {
          if (dri.productType === product.product && dri.productScheduleItem === product.guid) {
            filled += dri.quantity;
          }
        });
        return (
          <div
            key={product.guid}
            className="products"
            style={{
              width: (product.quantity / total) * expand * 100 + '%'
            }}
          >
            <div className="bar">
              <div
                className="consumed"
                style={{
                  width: (product.consumed / product.quantity) * 100 + '%'
                }}
              ></div>
              <div
                className="filled"
                style={{
                  width: Math.round(((filled ?? 0) / product.quantity) * 100) + '%'
                }}
              ></div>
              <span className="kilos">
                {(filled ?? 0) + product.consumed}/{product.quantity}
              </span>
            </div>
            <span className="below">
              {productTypes.find((pt) => pt.guid === product.product)?.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};
export default ScheduleBar;
